import React from 'react';

const ProductGallery = () => {
  const images = [
    {
      src: "/stock/pexels-moklebust-33756340.jpg",
      alt: "Supplement Capsules"
    },
    {
      src: "/stock/pexels-n-voitkevich-7615470.jpg",
      alt: "Natural Ingredients"
    },
    {
      src: "/stock/pexels-planka-28700281.jpg",
      alt: "Wellness Products"
    }
  ];

  return (
    <section className="product-gallery">
      <div className="gallery-grid">
        {images.map((image, index) => (
          <div key={index} className="gallery-item">
            <img src={image.src} alt={image.alt} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductGallery;
